//
// Copyright (C) 2025 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/HasSupportedValueInfo.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/HasSupportedValueInfo.proto.
 */
export const file_android_hardware_automotive_vehicle_HasSupportedValueInfo: GenFile = /*@__PURE__*/
  fileDesc("Cj9hbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9IYXNTdXBwb3J0ZWRWYWx1ZUluZm8ucHJvdG8SKWFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvInwKFUhhc1N1cHBvcnRlZFZhbHVlSW5mbxIfChdoYXNfbWluX3N1cHBvcnRlZF92YWx1ZRgBIAEoCBIfChdoYXNfbWF4X3N1cHBvcnRlZF92YWx1ZRgCIAEoCBIhChloYXNfc3VwcG9ydGVkX3ZhbHVlc19saXN0GAMgASgIYgZwcm90bzM");

/**
 * Must be in sync with HasSupportedValueInfo.aidl. 
 *
 * @generated from message android.hardware.automotive.vehicle.proto.HasSupportedValueInfo
 */
export type HasSupportedValueInfo = Message<"android.hardware.automotive.vehicle.proto.HasSupportedValueInfo"> & {
  /**
   * *
   * Whether [propId, areaId] has min supported value specified.
   *
   * If this is {@code true}, the hardware specifies a min supported value.
   * If {@code MinMaxSupportedValueResult}'s {@code status} is
   * {@code StatusCode.OK}, its {@code minSupportedValue} must not be
   * {@code null}.
   *
   * If this is {@code false}, {@code minSupportedValue} must be {@code null}.
   *
   * Unless otherwise specified, this field is set to {@code false} for any
   * properties whose type is not int32, int64 or float.
   *
   * For certain properties, e.g. {@code EV_BRAKE_REGENERATION_LEVEL}, this
   * must always be {@code true}. Check {@code VehicleProperty}
   * documentation.
   *
   * @generated from field: bool has_min_supported_value = 1;
   */
  hasMinSupportedValue: boolean;

  /**
   * *
   * Whether [propId, areaId] has max supported value specified.
   *
   * If this is {@code true}, the hardware specifies a max supported value.
   * If {@code MinMaxSupportedValueResult}'s {@code status} is
   * {@code StatusCode.OK}, its {@code maxSupportedValue} must not be
   * {@code null}.
   *
   * If this is {@code false}, {@code maxSupportedValue} must be {@code null}.
   *
   * Unless otherwise specified, this field is set to {@code false} for any
   * properties whose type is not int32, int64 or float.
   *
   * For certain properties, e.g. {@code EV_BRAKE_REGENERATION_LEVEL}, this
   * must always be {@code true}. Check {@code VehicleProperty}
   * documentation.
   *
   * @generated from field: bool has_max_supported_value = 2;
   */
  hasMaxSupportedValue: boolean;

  /**
   * *
   * Whether [propId, areaId] has supported values list specified.
   *
   * If this is {@code true}, it means the hardware specifies supported
   * values for this property.
   * If {@code SupportedValueListResult}'s {@code status} is
   * {@code StatusCode.OK}, its {@code supportedValuesList} must not be
   * {@code null}.
   *
   * If this is {@code false}, {@code supportedValuesList} must always be
   * {@code null}.
   *
   * The supported value is the superset for both the input value for writable
   * property and the output value for readable property.
   *
   * For certain properties, e.g. {@code GEAR_SELECTION}, this must always be
   * {@code true}. Check {@code VehicleProperty} documentation.
   *
   * @generated from field: bool has_supported_values_list = 3;
   */
  hasSupportedValuesList: boolean;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.HasSupportedValueInfo.
 * Use `create(HasSupportedValueInfoSchema)` to create a new message.
 */
export const HasSupportedValueInfoSchema: GenMessage<HasSupportedValueInfo> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_HasSupportedValueInfo, 0);

